import { ReactNode } from 'react';

import { useSelector } from 'react-redux';

import { cn } from '@/lib/utils';
import { Attachment } from '@/modules/humanChat/components/Conversation/MessageArea/Attachment/Attachment';
import { buildStoredFileUrl } from '@/modules/humanChat/hooks/useAttachment';
import { selectSessionSource } from '@/modules/tryIt/redux/selectors';
import { AuthorType } from '@/shared/types/chat';
import { ResponseMessage } from '@/shared/types/tryIt';

import { bubbleBrainClasses, MEDIA_FRAME, responseClasses } from './constants';

type VideoMessage = Extract<ResponseMessage, { type: 'video' }>;

interface VideoResponseProps {
  response: VideoMessage;
  authorType: `${AuthorType}`;
  icon: ReactNode;
  goToButton: ReactNode;
  turnRow?: boolean;
}

export const VideoResponse = ({
  response,
  authorType,
  icon,
  goToButton,
  turnRow = false,
}: VideoResponseProps) => {
  const source = useSelector(selectSessionSource);
  const fileUrl = buildStoredFileUrl(source, response.url, response.name);

  return (
    <div className={cn(responseClasses, '[&>*:last-child]:shrink-1')}>
      {icon}
      <div className={cn(turnRow ? MEDIA_FRAME : bubbleBrainClasses)}>
        {response.id ? (
          <Attachment
            source={source}
            attachment={{ id: response.id, type: 'video', mime_type: 'video/mp4' }}
            authorType={authorType}
          />
        ) : (
          <video src={fileUrl} className="rounded-md" controls />
        )}
      </div>
      {goToButton}
    </div>
  );
};
